import './ExploreMoreLine.css';

/**
 * A hairline rule with a clickable label in the middle — "explore more ›".
 *
 * Sits at the end of the closet strip so the last item is never a dead end.
 * A rule rather than another card: a card in the grid reads as another garment
 * you own, which is exactly what this is not.
 *
 * @param {Object} props
 * @param {Function} props.onClick - Opens the explore/community panel
 * @param {string} [props.label] - Override the label text
 */
const ExploreMoreLine = ({ onClick, label = 'explore more' }) => (
  <button type="button" className="explore-more-line" onClick={onClick}>
    <span className="explore-more-rule" />
    <span className="explore-more-text">
      {label} <span className="explore-more-chevron" aria-hidden="true">&rsaquo;</span>
    </span>
    <span className="explore-more-rule" />
  </button>
);

export default ExploreMoreLine;
